var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Feature, Layer } from 'react-mapbox-gl';
import { connect } from 'react-redux';
import { locationChange } from './actions';
var VEHICLE_PAINT = {
    'circle-stroke-width': 4,
    'circle-radius': 10,
    'circle-blur': 0.15,
    'circle-color': '#3770C6',
    'circle-stroke-color': 'white',
};
var BEARING_PAINT = {
    'icon-color': 'black',
};
var BEARING_LAYOUT = {
    'icon-image': 'triangle-11',
    'icon-rotation-alignment': 'map',
    'icon-rotate': ['get', 'bearing'],
    'icon-offset': [0, -14],
    'icon-size': 1,
    'icon-allow-overlap': true,
    'icon-padding': 0,
};
function onMouseEnter(e) {
    e.map._canvas.style.cursor = 'move';
}
function onMouseLeave(e) {
    e.map._canvas.style.cursor = null;
}
var VehicleMarker = /** @class */ (function (_super) {
    __extends(VehicleMarker, _super);
    function VehicleMarker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.counter = 1;
        _this.onDrag = function (e) {
            // For performance reasons we're not emitting a move event every time.
            if (_this.counter % 16 === 0) {
                _this.props.locationChange(e.lngLat.lat, e.lngLat.lng);
            }
            _this.counter++;
        };
        _this.onDragEnd = function (e) {
            _this.counter = 0;
            _this.onDrag(e);
        };
        return _this;
    }
    VehicleMarker.prototype.render = function () {
        var location = this.props.location;
        if (!location) {
            return null;
        }
        var longitude = location.longitude, latitude = location.latitude, bearing = location.bearing;
        var coordinates = [longitude, latitude];
        return (React.createElement(React.Fragment, null,
            React.createElement(Layer, { id: "vehicle", type: "circle", paint: VEHICLE_PAINT },
                React.createElement(Feature, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, draggable: true, onDrag: this.onDrag, onDragEnd: this.onDragEnd, coordinates: coordinates })),
            bearing && React.createElement(Layer, { id: "vehicle-bearing", type: "symbol", paint: BEARING_PAINT, layout: BEARING_LAYOUT },
                React.createElement(Feature, { coordinates: coordinates, properties: location }))));
    };
    return VehicleMarker;
}(React.PureComponent));
export default connect(function (_a) {
    var location = _a.location;
    return ({ location: location });
}, { locationChange: locationChange })(VehicleMarker);



//////////////////
// WEBPACK FOOTER
// ./src/components/MapControl/Vehicle.tsx
// module id = 1756
// module chunks = 0